(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sg-balenciaga-fashion-opening"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const root = document.querySelector('[data-guide-handle="balenciaga"]');
    const inner = root && root.querySelector('.sg-designer-guide__inner');
    if (!inner || inner.dataset.sgCollapsed) return;
    inner.dataset.sgCollapsed = 'true';
    const intro = document.createElement('div');
    intro.className = 'sg-bal-reference-intro';
    intro.innerHTML = '<h2>Explore the guide</h2><p>Choose a chapter. Open only what you need.</p>';
    const chapters = [...inner.children].filter(el => el.matches('section,aside'));
    inner.prepend(intro);
    chapters.forEach(el => {
      const heading = el.querySelector('h2');
      if (!heading) return;
      const details = document.createElement('details');
      details.className = 'sg-bal-reference';
      const summary = document.createElement('summary');
      summary.textContent = el.id === 'sg-collector-atlas' ? 'Downloadable collector’s guides' : el.id.startsWith('sg-code-tool-') ? 'Analyze a tag' : heading.textContent;
      el.before(details);
      details.append(summary, el);
    });
    const reveal = hash => {
      if (!hash || hash === '#') return;
      let target;
      try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (_) { return; }
      if (!target || !root.contains(target)) return;
      let node = target;
      while (node && node !== root) { if (node.tagName === 'DETAILS') node.open = true; node = node.parentElement; }
      requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
    };
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      if (link && root.contains(link)) reveal(link.getAttribute('href'));
    });
    window.addEventListener('hashchange', () => reveal(location.hash));
    reveal(location.hash);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sg-color-outfit-edit"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = root => {
    if (root.dataset.rotating) return;
    const grid = root.querySelector('.sg-outfit-grid');
    const reserve = [...root.querySelectorAll('[data-outfit-reserve]')].map(t => t.content.querySelector('[data-outfit-card]')).filter(Boolean);
    if (!reserve.length) return;
    root.dataset.rotating = 'true';
    const pause = root.querySelector('[data-outfit-pause]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduced.matches;
    let inView = false;
    let busy = false;
    let last = -1;
    const sync = () => {
      pause.textContent = paused ? pause.dataset.playLabel : pause.dataset.pauseLabel;
      pause.setAttribute('aria-pressed', String(paused));
    };
    pause.hidden = false;
    pause.addEventListener('click', () => { paused = !paused; sync(); });
    reduced.addEventListener('change', e => { if (e.matches) { paused = true; sync(); } });
    sync();
    const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; });
    observer.observe(grid);
    const protectedCard = card => card.matches(':hover') || card.contains(document.activeElement);
    const timer = setInterval(async () => {
      if (!root.isConnected) { clearInterval(timer); observer.disconnect(); return; }
      if (paused || busy || !inView || document.hidden) return;
      const cards = [...grid.querySelectorAll('[data-outfit-card]')];
      const eligible = cards.map((card, index) => ({ card, index })).filter(({ card, index }) => index !== last && !protectedCard(card));
      if (!eligible.length) return;
      const { card, index } = eligible[Math.floor(Math.random() * eligible.length)];
      const reserveIndex = Math.floor(Math.random() * reserve.length);
      const next = document.importNode(reserve[reserveIndex], true);
      const img = next.querySelector('img');
      busy = true;
      try {
        img.loading = 'eager';
        await img.decode();
        if (paused || !inView || document.hidden || protectedCard(card) || !card.isConnected) return;
        const motion = !reduced.matches;
        if (motion) await card.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160 }).finished;
        if (paused || document.hidden || protectedCard(card) || !card.isConnected) return;
        reserve[reserveIndex] = card.cloneNode(true);
        card.replaceWith(next);
        last = index;
        if (motion) await next.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220 }).finished;
      } catch {} finally { busy = false; }
    }, 3000);
  };
  document.querySelectorAll('[data-sg-outfit]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-sg-outfit]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sg-product-copy-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sg-product-copy-controls')) {
  customElements.define('sg-product-copy-controls', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.mount());
    }
    mount() {
      const root = this.closest('product-page');
      if (!root || !this.isConnected || this.mounted) return;
      this.mounted = true;
      const status = document.createElement('span');
      status.className = 'sg-copy-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      root.append(status);
      const createButton = (label, value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sg-product-copy-button';
        button.setAttribute('aria-label', label);
        button.title = label;
        button.innerHTML = '<svg class="sg-copy-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="8" y="8" width="12" height="13" rx="2"></rect><path d="M15 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3"></path></svg><svg class="sg-copy-check" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m5 12 4 4 10-10"></path></svg>';
        let reset;
        button.addEventListener('click', async () => {
          try {
            const text = value();
            if (!text) return;
            let copied = false;
            if (navigator.clipboard && window.isSecureContext) {
              try { await navigator.clipboard.writeText(text); copied = true; } catch (error) {}
            }
            if (!copied) {
              const field = document.createElement('textarea');
              field.value = text;
              field.setAttribute('readonly', '');
              field.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
              document.body.append(field);
              field.select();
              try { copied = document.execCommand('copy'); } finally { field.remove(); button.focus({preventScroll:true}); }
              if (!copied) throw new Error('copy');
            }
            button.dataset.copied = 'true';
            button.title = this.dataset.copied;
            status.textContent = this.dataset.copied;
            clearTimeout(reset);
            reset = setTimeout(() => { delete button.dataset.copied; button.title = label; status.textContent = ''; }, 1800);
          } catch (error) { status.textContent = this.dataset.error; }
        });
        return button;
      };
      const title = root.querySelector('.product-text > .product__title');
      if (title) {
        const row = document.createElement('div');
        const style = getComputedStyle(title);
        row.className = 'sg-copy-title-row';
        row.style.marginBlockStart = style.marginBlockStart;
        row.style.marginBlockEnd = style.marginBlockEnd;
        row.style.fontSize = style.fontSize;
        row.style.lineHeight = style.lineHeight;
        title.before(row);
        row.append(title, document.createTextNode('\u00a0'), createButton(this.dataset.copyTitle, () => title.textContent.trim()));
      }
      const description = root.querySelector('.product__description');
      if (!description || description.querySelector('.sg-product-copy-button')) return;
      const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT, {
        acceptNode: node => node.parentElement.closest('script,style,button') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
      });
      let node;
      while ((node = walker.nextNode())) {
        const label = /\bSKU\s*:\s*/i.exec(node.textContent);
        if (!label) continue;
        let valueNode = node;
        let offset = label.index + label[0].length;
        let value = node.textContent.slice(offset);
        while (!value.trim() && (valueNode = walker.nextNode())) { offset = 0; value = valueNode.textContent; }
        const sku = /^\s*([A-Za-z0-9][A-Za-z0-9._\/-]*)/.exec(value);
        if (!valueNode || !sku || /^(category|brand|gender|size)$/i.test(sku[1])) return;
        const range = document.createRange();
        range.setStart(valueNode, offset + sku[0].length);
        range.collapse(true);
        range.insertNode(createButton(this.dataset.copySku, () => sku[1]));
        break;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sg-product-size-reference"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sg-size-reference')){
  let guideRequest;
  const loadGuide=()=>guideRequest||(guideRequest=fetch('/pages/sui-generis-size-guide').then(r=>{if(!r.ok)throw Error('guide');return r.text()}).then(html=>new DOMParser().parseFromString(html,'text/html')).catch(error=>{guideRequest=null;throw error}));
  customElements.define('sg-size-reference',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      const trigger=this.querySelector('.sg-fit-trigger'),dialog=this.querySelector('dialog'),select=this.querySelector('select'),chart=this.querySelector('.sg-fit-chart');
      trigger.addEventListener('click',event=>{if(typeof dialog.showModal!=='function')return;event.preventDefault();dialog.showModal()});
      this.querySelector('.sg-fit-close').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('close',()=>trigger.focus());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}});
      select.addEventListener('change',async()=>{
        const selected=select.value;chart.replaceChildren();if(!selected)return;
        chart.textContent=chart.dataset.loading;
        try{
          const doc=await loadGuide();if(select.value!==selected)return;
          const isGucci=(this.dataset.vendor||'').toLowerCase().includes('gucci')&&selected==='mens-shoes';
          const source=doc.getElementById(isGucci?'gucci-mens-sizing':selected);if(!source)throw Error('chart');
          const copy=source.cloneNode(true);copy.querySelectorAll('[id]').forEach(n=>n.removeAttribute('id'));copy.removeAttribute('id');copy.removeAttribute('aria-labelledby');
          chart.replaceChildren(copy);
        }catch(error){if(select.value===selected)chart.textContent=chart.dataset.error}
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sg-search-panel"] && !Shopify.designMode) return;
  try {
    (() => {
  let input;
  let panel;
  let frame;
  let panelObserver;
  const schedule = () => { if (!frame) frame = requestAnimationFrame(align); };
  const align = () => {
    frame = 0;
    if (!input || !panel || !input.isConnected) return;
    const anchor = input.closest('.sg-search-field') || input.closest('form[role="search"]') || input;
    const rect = anchor.getBoundingClientRect();
    if (!rect.width) return;
    const width = Math.min(rect.width, document.documentElement.clientWidth - 24);
    const left = Math.max(12, Math.min(rect.left, document.documentElement.clientWidth - width - 12));
    const top = Math.max(8, rect.bottom + 8);
    const height = Math.max(100, window.innerHeight - top - 16);
    const values = {left, top, width, height};
    Object.entries(values).forEach(([name, value]) => {
      const property = '--sg-search-' + name;
      const next = value + 'px';
      if (panel.style.getPropertyValue(property) !== next) panel.style.setProperty(property, next);
    });
    panel.classList.add('sg-search-panel');
    panel.classList.toggle('sg-search-panel-narrow', width < 640);
  };
  const discover = () => {
    const next = document.getElementById('snize-instant-search-results');
    if (next && next !== panel) {
      panelObserver?.disconnect();
      panel = next;
      panelObserver = new MutationObserver(schedule);
      panelObserver.observe(panel, {attributes:true, attributeFilter:['style'], childList:true});
    }
    schedule();
  };
  const track = event => {
    const target = event.target;
    if (target instanceof HTMLInputElement && (target.type === 'search' || target.getAttribute('aria-controls') === 'snize-instant-search-results')) {
      input = target;
      discover();
    }
  };
  document.addEventListener('focusin', track);
  document.addEventListener('input', track);
  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('scroll', schedule, {passive:true, capture:true});
  window.visualViewport?.addEventListener('resize', schedule);
  new MutationObserver(discover).observe(document.body, {childList:true});
  discover();
})();
  } catch(e) { console.error(e); }
})();

})();
